/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import BaseStat from './base-stat';

export default BaseStat.extend({
  reaction: attr('string'),
});
